import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cx } from './cx';

interface EmptyStateProps {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  /** Geste proposé pour sortir de l'état vide (bouton `sm`). */
  action?: ReactNode;
  className?: string;
}

/** État vide : cadre en pointillés, icône sur pastille blanche, une action. */
export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cx(
        'flex items-center gap-4 rounded-row border-[1.5px] border-dashed border-line bg-surface-light p-[18px] max-sm:flex-wrap',
        className,
      )}
    >
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-[14px] bg-white text-primary shadow-card">
        <Icon size={18} strokeWidth={1.9} aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold tracking-[-.3px] text-heading">{title}</p>
        {description && <p className="mt-0.5 text-[12.5px] text-secondary">{description}</p>}
      </div>
      {/* Téléphone : l'action passe sous le texte. */}
      {action && <div className="shrink-0 max-sm:basis-full max-sm:pl-[60px]">{action}</div>}
    </div>
  );
}
